export default __webpack_public_path__ + "static/Concrete-Foundation-Removal-5373da87964f0397e029750469e850f0.jpg";